import { render } from "./CPOChargerStatusDashboard.vue?vue&type=template&id=2fb5a15b&scoped=true"
import script from "./CPOChargerStatusDashboard.vue?vue&type=script&lang=js"
export * from "./CPOChargerStatusDashboard.vue?vue&type=script&lang=js"

import "./CPOChargerStatusDashboard.vue?vue&type=style&index=0&id=2fb5a15b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fb5a15b"]])

export default __exports__